import(/* webpackMode: "eager" */ "/Users/feker/Desktop/Feker-repo/ShahenWebsite/src/app/(home)/page.jsx");
